import { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { IsActiveMatchOptions, Route, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, tap } from 'rxjs';
import { SideNavItemBaseComponent } from './sidenav.item.base.component';

@UntilDestroy()
@Component({
    selector: 'sidenav-item',
    template: `
    
    <ng-container *ngIf="route?.children?.length; then hasMenu; else noMenu"></ng-container>

    <ng-template #hasMenu>

        <div class="side-nav-item has-menu" [attr.data-tour-target]="route.path"
             *ngIf="route.data.icon"  
             cdkOverlayOrigin 
             #trigger="cdkOverlayOrigin" 
             (mouseenter)="open = true" 
             [ngClass]="{ active: active} "
             >

            <i class="fa" [ngClass]="route.data.icon"></i>
            <span class='title'>{{route?.data?.title}}</span>

            <ng-template cdkConnectedOverlay 
                [cdkConnectedOverlayOrigin]="trigger"] 
                [cdkConnectedOverlayOpen]="open"]
                [cdkConnectedOverlayPositions]="positions"]
                [cdkConnectedOverlayScrollStrategy]="overlay.scrollStrategies.close()"]
                (attach)="onAttached()"
                (detach)="open = false"
                (overlayOutsideClick)="open = false"
                >
                <!-- <sidenav-menu [route]="route" (clicked)="open = false" (mouseleave)="open = false"></sidenav-menu> -->
                <sidenav-menu [route]="route" (clicked)="open = false" (mouseleave)="open = false"></sidenav-menu>
            </ng-template>

            <div cdkOverlayContainer ></div>

        </div>



    </ng-template>
    <ng-template #noMenu>
        <a class="side-nav-item" routerLink="/{{route.path}}" routerLinkActive="active" *ngIf="route.data.icon" (mouseenter)="onForceClose()" >
            <i class="fa" [ngClass]="route.data.icon"></i>
            <span class='title'>{{route?.data?.title}}</span>
        </a>
    </ng-template>


    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SideNavItemComponent extends SideNavItemBaseComponent {

    @Input() public route: Route;

    public positions = [{
        originX: 'end',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
    } as ConnectedPosition];

    public isActiveOptions: IsActiveMatchOptions = {
        matrixParams: 'ignored',
        queryParams: 'ignored',
        paths: 'subset',
        fragment: 'ignored'
    };

    constructor(
        public overlay: Overlay,
        protected cdr: ChangeDetectorRef,
        public router: Router
    ) {
        super(cdr);
    }

    ngOnInit(): void {

        this.active = this.router.isActive(this.route.path, this.isActiveOptions);

        if (this.route?.children?.length) {
            this.router
                .events
                .pipe(
                    untilDestroyed(this),
                    tap(x => {
                        this.active = this.router.isActive(this.route.path, this.isActiveOptions);
                        this.cdr.markForCheck();
                    })
                )
                .subscribe();
        }
    }

    ngOnDestroy(): void { }
}
